import React from "react";
import { ListItem } from "material-ui/List";
import PropTypes from "prop-types";

const CustomListItem = props => {
    const callKeyDown = event => {
        if (event.keyCode === 13) {
            event.preventDefault();
            props.onClick(event);
        }
    };

    return <ListItem {...props} onKeyboardFocus={callKeyDown} />;
};
CustomListItem.muiName = "ListItem";
CustomListItem.contextTypes = ListItem.contextTypes;
CustomListItem.defaultProps = {
    ...ListItem.defaultProps,
    onClick: () => {}
};
CustomListItem.propTypes = {
    ...ListItem.propTypes,
    onClick: PropTypes.func
};
export default CustomListItem;
